import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ec08b626")

_pushScopeId("data-v-ec08b626")
const _hoisted_1 = {
  class: "p-0.5 bg-gray-lp-1500 inline-flex flex-row items-center text-sm",
  style: {"border-radius":"100px"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (item, index) => {
      return (_openBlock(), _createBlock("div", { key: index }, [
        _createVNode("div", {
          class: ["justify-center items-center gap-2 flex z-10 py-2 cursor-pointer", 
          `${
            _ctx.modelValue.value === item.value
              ? 'leaderboard-filter-active'
              : 'leaderboard-filter-inactive'
          }`
        ],
          style: {"border-radius":"100px"},
          onClick: ($event: any) => (_ctx.onSelectFilter(item))
        }, [
          _createVNode(_component_Icons, {
            name: _ctx.maplabelIcon(item),
            class: 
            `${
              _ctx.modelValue.value === item.value
                ? 'leaderboard-icon-active'
                : 'leaderboard-icon-inactive'
            }`
          
          }, null, 8, ["name", "class"]),
          _createVNode("span", null, _toDisplayString(item.label), 1)
        ], 10, ["onClick"])
      ]))
    }), 128))
  ]))
})